import { render, staticRenderFns } from "./OnlineMenuBackground.vue?vue&type=template&id=09e27442&"
import script from "./OnlineMenuBackground.vue?vue&type=script&lang=js&"
export * from "./OnlineMenuBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports